import { Box, Typography } from "@mui/material";
import { useContext, useState } from "react";
import CustomButton from "../UIElements/CustomButton";
import "../components-styles.scss";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import PasswordInput from "../UIElements/PasswordInput/PasswordInput";
import InputField from "../UIElements/InputField";
import CustomLink from "../UIElements/CustomLink";
import { useNavigate } from "react-router-dom";
import { AuthContext, CustomModalContext } from "../../contexts";
import { emailRegExp } from "../../consts";
import ChangePasswordModalContent from "./ChangePasswordModalContent";
import CustomModal from "../UIElements/CustomModal/CustomModal";
import { resetPasswordRequest } from "../../services/auth/password.service";
import { RoutesEnum } from "../../router/routes";

const validationSchema = yup.object({
    email: yup
        .string()
        .email("Veuillez renseigner un identifiant valide")
        .matches(emailRegExp)
        .required("Veuillez renseigner votre identifiant"),
    password: yup.string().required("Veuillez renseigner un mot de passe"),
});

export default function LoginForm() {
    const {
        handleSubmit,
        formState: { errors },
        watch,
        control,
    } = useForm({
        defaultValues: {
            email: "",
            password: "",
        },
        resolver: yupResolver(validationSchema),
    });
    const {
        modal: { content: customModalContent, title },
    } = useContext(CustomModalContext);

    const { updateModal, updateIsCustomModalActive } =
        useContext(CustomModalContext);

    const navigate = useNavigate();
    const [error, setError] = useState<string>("");

    const { login } = useContext(AuthContext);

    const passwordValue = watch("password");

    const onSubmit = async (data: any) => {
        const loginRes = await login(data);
        if (loginRes.detail) {
            setError(loginRes.detail);
        } else {
            navigate("/monespace");
        }
    };
    const handlePasswordForgotten = async (eMail: string) => {
        await resetPasswordRequest(eMail);
        updateIsCustomModalActive(false);
    };
    return (
        <Box className="signup-form-root">
            <Typography className="login-title">
                Je me connecte à mon compte
            </Typography>
            <form onSubmit={handleSubmit(onSubmit)} className="signup-form">
                <Controller
                    name={`email`}
                    control={control}
                    render={({ field: { ref, ...others } }) => (
                        <InputField
                            {...others}
                            type="text"
                            id="username"
                            name="username"
                            autoComplete="email"
                            label={"Identifiant"}
                            errortext={errors?.email?.message ?? ""}
                        />
                    )}
                />
                <Controller
                    name="password"
                    control={control}
                    render={({ field: { ref, ...others } }) => (
                        <PasswordInput
                            fullWidth={true}
                            {...others}
                            id="password"
                            name="password"
                            label={"Mot de passe"}
                            havePasswordChecker={true}
                            errortext={errors.password?.message ?? ""}
                            showvisibility={(passwordValue || "").length}
                        />
                    )}
                />

                <Box
                    sx={{
                        color: "#E51846",
                    }}
                >
                    {error ?? (
                        <Typography
                            sx={{
                                fontSize: {
                                    xs: "15px",
                                    md: "17px",
                                },
                                fontWeight: "600",
                                fontFamily: "Roboto",
                                marginBottom: "10px",
                            }}
                        >
                            {error}
                        </Typography>
                    )}
                </Box>

                <CustomButton type="submit" label="Je me connecte" />
                <CustomLink
                    label="J'ai oublié mon mot de passe"
                    type="button"
                    sx={{
                        margin: "auto",
                    }}
                    onClick={() => {
                        updateModal({
                            content: (
                                <ChangePasswordModalContent
                                    onSucessChangePassWord={
                                        handlePasswordForgotten
                                    }
                                />
                            ),
                            title: "Gestion du mot de passe",
                        });
                        updateIsCustomModalActive(true);
                    }}
                />
            </form>

            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    justifyContent: "center",
                    flexDirection: "row",
                    margin: "auto",
                }}
            >
                <Typography
                    sx={{
                        color: "#023",
                        fontFamily: "Roboto",
                        fontSize: "12px",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "normal",
                    }}
                >
                    Je n’ai pas de compte
                </Typography>
                <CustomLink
                    onClick={() => navigate("/" + RoutesEnum.signup)}
                    label="Créer un compte"
                />
            </Box>
            <CustomModal title={title}>{customModalContent}</CustomModal>
        </Box>
    );
}
